<div #reportCard class="se-history-card" (click)="onCardSelected()" [class.se-card-selected]="isExpanded || item.selected">

    <div class="se-history-panel" (click)="toggleExpanded()">
        <!-- Data Referto - Esami-->
        <div style="display:flex;flex-direction:row">
            <span class="se-history-label se-history-multi-value">{{'ReportDate' | translate}}</span>
            @if(!!item.examsDescriptions) {
            <span class="se-history-label se-history-multi-value se-history-space">{{'Exams' | translate}}</span>
            }
        </div>
        <div style="display:flex;flex-direction:row">
            <span class="se-history-value se-history-multi-value" [ngClass]="{'se-history-value-truncated': !isExpanded}" seEllipsisWithTooltip>{{item.reportDate | date:'dd/MM/yyyy HH:mm'}}</span>
            <span class="se-history-value se-history-multi-value se-history-space" [ngClass]="{'se-history-value-truncated': !isExpanded}" seEllipsisWithTooltip>{{item.examsDescriptions}}</span>
        </div>

        <div [@expansionAnimation] *ngIf="isExpanded" class="se-history-expansion-panel">
            <!-- Medico Refertatore-->
            <div style="display:flex;flex-direction:row">
                @if(!!item.referringPhysicians) {
                <span class="se-history-label se-history-multi-value" seEllipsisWithTooltip>{{'ReferringPhysician' | translate}}</span>
                }
            </div>
            <div style="display:flex;flex-direction:row">
                @if(!!item.referringPhysicians) {
                <span class="se-history-value se-history-multi-value" seEllipsisWithTooltip>{{item.referringPhysiciansName}}</span> <!-- PUò ESSERE PIù DI 1 -->
                }
            </div>

            <div style="display:flex;flex-direction:row">
                @if(!!item.text) {
                <span class="se-history-label" *ngIf="!!item.text">{{'Report' | translate}}</span>
                }
                <!-- Importa conclusioni - visibile solo dentro le cp -->
                @if(!!item.text && isCp) {
                <button mat-icon-button
                        class="se-button-no-ripple copy-button"
                        (click)='copyReport($event, item)'
                        [style.display]="(item.text) ? 'block' : 'none'"
                        matTooltip="{{'Import' | translate}} {{'Report' | translate}}">
                    <mat-icon style="font-size: 22px!important;" class="se-side-small-icon icon-color">content_copy</mat-icon>
                </button>
                }
            </div>
            <div style="display:flex;flex-direction:row; width: 100%">
                @if(!!item.text) {
                <span class="se-history-value"
                      (click)="$event.stopPropagation()"
                      style="user-select: text; cursor: default; width: 100%">{{item.text}}</span>
                }
            </div>
        </div>
    </div>

    <div class="se-history-footer-panel" [class.se-history-footer-selected-panel]="isExpanded || item.selected">

        <!-- Referto PDF -->
        <button mat-icon-button
                class="se-button-no-ripple"
                [style.display]="((item.reportDate && item.reportKey) || item.printReport) ? 'block' : 'none'"
                (click)='openPdf($event)'
                matTooltip="PDF">
            <!-- manca reportKey -->
            <mat-icon style="font-size: 22px!important;" class="se-side-small-icon material-icons-outlined icon-color">picture_as_pdf</mat-icon>
        </button>
        <!-- Immagini -->
        <button mat-icon-button
                class="se-button-no-ripple"
                [style.display]="(item.imagesAvailability) && isAuthorized ? 'block' : 'none'"
                (click)='openImagesByEprEvent($event)'
                matTooltip="{{'Images' | translate}}">
            <!-- manca isAuthorized, cos'è? -->
            <mat-icon style="font-size: 22px!important;" class="se-side-small-icon material-icons-outlined icon-color">collections</mat-icon>
        </button>

    </div>
</div>
